import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { IHeroWithVideoProps } from '../components/hero-with-video/hero-with-video';

export class HeroWithVideoModel extends ContentItem {
  get children(): IKontentItem[] {
    return get(this._config, 'elements.items.value', []);
  }

  get videoUrl(): { url: string } {
    return get(this._config, 'elements.video.value[0]', '');
  }

  get dotsInBackground(): boolean {
    return (
      get(this._config, 'elements.dots_in_background.value[0].codename', '') ===
      'true'
    );
  }

  public static create(data: IHeroWithVideo): IHeroWithVideoProps {
    const { children, videoUrl, dotsInBackground } = new HeroWithVideoModel(
      data
    );
    return {
      children,
      videoUrl,
      dotsInBackground
    };
  }
}
